import {Label} from "./label";

// 전체 라벨배열
let labels = {};

/**
 * 라벨 추가
 * @param opts
 */
function add_label(opts) {
    let label = new Label(opts);
    labels[label.id] = label;
}


// 무지라벨 - 독일(디첸바흐)
add_label({
    id: 'empty-c',
    name: '무지(100x180)',
    emptyLine: true,
    size: {width: 104, height: 184},
    stickySize: {width: 100, height: 180},
    margins: {top: 2, right: 2, bottom: 5, left: 2},
});

// 무지라벨 - 호주(시드니)
add_label({
    id: 'empty-longtype',
    name: '무지',
    emptyLine: true,
    size: {width: 104, height: 204},
    stickySize: {width: 100, height: 200},
    margins: {top: 2, right: 2, bottom: 5, left: 2},
});

// 무지라벨 - 호주(브리즈번), 영국, 독일(켈스터바흐 region 17 공유)
add_label({
    id: 'empty-a',
    name: '무지',
    emptyLine: true,
    size: {width: 105, height: 156},
    stickySize: {width: 100, height: 152},
    margins: {top: 2, right: 2, bottom: 5, left: 2},
});

// 무지라벨 - 미국(오레곤)
add_label({
    id: 'empty-b',
    name: '무지(4x6 inch)',
    emptyLine: true,
    size: {width: 105, height: 156},
    stickySize: {width: 101, height: 152},
    margins: {top: 2, right: 2, bottom: 5, left: 2},
});

// 우체국 송장
add_label({
    id: 'epost-ctype',
    name: '우체국송장(C형)',
    emptyLine: false,
    size: {width: 111, height: 172},
    stickySize: {width: 107, height: 168},
    margins: {top: 2, right: 2, bottom: 5, left: 2},
});

// 우체국 송장 구형 (사이즈는 신형과 같음)
add_label({
    id: 'epost-old',
    name: '우체국송장(구형)',
    emptyLine: false,
    size: {width: 111, height: 172},
    stickySize: {width: 107, height: 168},
    margins: {top: 2, right: 2, bottom: 5, left: 2},
});

// 우체국 송장(캐나다 프린터가 이상하게 좌측이 짤려서 좌측 마진을 많이잡음)
add_label({
    id: 'epost-ctype-canda',
    name: '우체국송장(C형) 캐나다',
    emptyLine: false,
    size: {width: 111, height: 172},
    stickySize: {width: 107, height: 168},
    margins: {top: 2, right: 2, bottom: 20, left: 2},
});

// CJ 신형 송장
add_label({
    id: 'cj-5inch',
    name: 'CJ송장(신형 5inch)',
    emptyLine: false,
    size: {width: 105, height: 126},
    stickySize: {width: 100, height: 123},
    margins: {top: 2, right: 2, bottom: 5, left: 2},
});

//console.log(labels);

export function get_label(id) {
    return labels[id];
}

// 전체라벨
export const total_labels = labels;



// 각 지역(센터)별 등록 라벨
class RegionLabels {
    constructor(label_ids) {
        this.labels = {};
        this.defaultLabel = null;

        label_ids.forEach(label_id => {

            let label = get_label(label_id);
            this.labels[label_id] = label;

            // 첫번째 라벨을 기본라벨로 지정
            if (! this.defaultLabel) {
                this.defaultLabel = label;
            }
        });
    }

    get_label(label_id) {
        return this.labels[label_id];
    }
}

let region_labels = {
    // 미국(뉴저지)
    2: new RegionLabels([
        'epost-ctype',
    ]),
    
    // 독일(프랑크프루트)
    6: new RegionLabels([
        'epost-old',
    ]),

    // 호주(브리즈번) — TASK-152 무지라벨 100×152 (empty-a) 전환 — 센터는 PNG 방식 전용 (ZPL 병행 코드는 유지하나 사용 안 함)
    7: new RegionLabels(['empty-a']),

    // 일본-항공(오사카)
    9: new RegionLabels([
        'epost-ctype',
    ]),

    // 일본-해상(오사카)
    10: new RegionLabels([
        'cj-5inch',
    ]),

    // 호주(시드니)
    11: new RegionLabels([
        'empty-longtype',
        //'epost-ctype',
    ]),

    // 미국(오레곤)
    12: new RegionLabels([
        'empty-b',
    ]),


    // 독일(디첸바흐)
    13: new RegionLabels([
        'empty-c',
    ]),

    // 캐나다(1센터)
    15: new RegionLabels([
        'epost-ctype-canda',
    ]),

    // 캐나다 — TASK-134 GSM 전환으로 무지라벨(호주 브리즈번·영국·독일 켈스터바흐와 동일 용지 empty-a 100x152) 사용
    16: new RegionLabels([
        'empty-a',
        //'epost-ctype',
    ]),

    // 독일(켈스터바흐) — TASK-081 무지라벨 (호주 브리즈번·영국과 동일 용지 empty-a 재사용)
    17: new RegionLabels([
        'empty-a',
    ]),
};

export function get_region_labels(region_id) {
    return region_labels[region_id];
}